import React from 'react'

const GALAUSD = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48' fill='none'>
      <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' fill='white' />
      <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' stroke='#D1D3E5' />
      <path
        d='M24.1307 7L9.89981 14.6989L24.1461 22.9209L29.5834 19.7737L27.2933 18.4594L24.1461 20.2792L14.5965 14.7715L24.1461 9.60221L25.0735 10.1165L36.0515 16.0506L38.3812 14.7077L24.1307 7Z'
        fill='black'
      />
      <path
        d='M17.9077 20.9822V23.624L21.1253 25.49V36.8988L11.2901 30.8504V17.1603L9 15.8394V32.1317L23.4155 40.9999V24.1625L17.9077 20.9844V20.9822Z'
        fill='black'
      />
      <path
        d='M37.5254 16.8348L24.8463 24.16V30.5908L27.1341 29.2678V25.4897L36.9694 19.8106V30.859L27.1341 36.9007L24.8463 38.3095V40.9975L39.2595 32.1293V15.8281L37.5254 16.8348Z'
        fill='black'
      />
    </svg>
  )
}

export default GALAUSD
